import React, { Component } from 'react';
import { Button, Card, Col, Container, Modal, Row } from 'react-bootstrap';
import { Company } from '../models/Company';
import { Invoice } from '../models/Invoice';
import { Link } from 'react-router-dom';

interface SearchResultsProps {
  selectedCompany?: Company;
  selectedInvoice?: Invoice[],
  selectedPolicy?: string,
  handleSearchAgain: () => void,

}

interface SearchResultsState {
  showModal: boolean;
}

class SearchResults extends Component<SearchResultsProps, SearchResultsState> {
  state: SearchResultsState = { showModal: false };

  getContinueButton() {
    if (this.props.selectedCompany) {
      return (

        <Link to={{
          pathname: "/pay-now",
          state: {

            policyNumber: this.props.selectedCompany?.policyNumber,
            impersonationToken: this.props.selectedCompany?.impersonationToken,
            selectedInvoice: this.props.selectedInvoice,
            selectedCompany: this.props.selectedCompany,
          }

        }}>



{<Button
            variant='primary'
            className='float-right'
            disabled={!this.props.selectedCompany?.name}
          >
            Continue to Payment
          </Button> as any}
        </Link >
      );
    } else {
      return null;
    }
  }
  render() {


    return (
      <Container>
        <Card>
          <Card.Header
            className='text-center'
            style={{
              fontSize: '28px',
              color: 'white',
              backgroundColor: '#1313b7'
            }}
          >
            Search Results
          </Card.Header>
          <Card.Body>
            <Row>
              <Col>
                <p><strong>{this.props.selectedCompany?.name ? this.props.selectedCompany.name : 'Sorry, there were no results.'}</strong></p>
                <p>{this.props.selectedCompany?.name ? this.props.selectedCompany.policyNumber : ''}</p>
                <p>If this is your company, continue on to make a payment. If not, you can search again or
                  continue on with no policy information.</p>
              </Col>
            </Row>
            <Row>
              <Col>
                <Button variant='secondary' onClick={this.props.handleSearchAgain}>Search Again</Button>
                {this.getContinueButton()}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    );
  }
}

export default SearchResults;
